import(/* webpackMode: "eager" */ "/codebuild/output/src3564205306/src/app/home/page.tsx");
